var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"loader-card"},[_c('div',{staticClass:"loader-container"},[_c('v-progress-circular',{attrs:{"size":160,"width":8,"color":"#436074","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }